import React from 'react';
import { User } from '../../../../../../models/interfaces/User.interface';
import { Link, useNavigate, useOutletContext } from 'react-router-dom';
import { ProductCategory } from '../../../../../../models/interfaces/ProductCategory.interface';
import CategoryFormComponent from '../../components/category-form/category-form.component';
import ProductTableComponent from '../../../product-context/components/product-table/product-table.component';
import { BusinessObject } from '../../../../../../models/interfaces/BusinessObject.interface';
import { makeStyles } from '@mui/styles';
import { Button } from '@mui/material';
import { Add } from '@mui/icons-material';
import routeService from '../../../../../../routes/route.service';

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  createNewProductButton: {
    marginBottom: '20px',
  },
});

export default function CategoryDetailComponent() {
  const navigate = useNavigate();

  const { user, businessObject, category } = useOutletContext<{
    user: User;
    businessObject: BusinessObject;
    category: ProductCategory;
  }>();

  const handleCreateProduct = () => {
    navigate(routeService.getAndFillProductCreatePath(user?.id, businessObject?.id, category?.id));
  };

  const classes = useStyles();

  return (
    <>
      <CategoryFormComponent ownerId={user?.id} businessObjectId={businessObject?.id} category={category} />

      <Button
        onClick={handleCreateProduct}
        variant="contained"
        color="primary"
        className={classes.createNewProductButton}
        startIcon={<Add />}
      >
        Create new product
      </Button>

      <ProductTableComponent
        userId={user?.id}
        businessObjectId={businessObject?.id}
        categoryId={category?.id}
        products={category?.products}
      />

      <div>
        <Link to={routeService.getAndFillBusinessObjectDetailPath(user?.id, businessObject?.id)}>
          Back to business object
        </Link>
      </div>
    </>
  );
}
